import { authService } from '../login';

/**
 * Sends an authenticated request to the back-end API.
 * 
 * @param {string} path The API path.
 * @param {RequestInit?} init Custom settings to apply to the request.
 */
export function apiFetch(path, init = {}) {
    init.headers = new Headers(init.headers);

    if (!init.headers.has('Authorization'))
        init.headers.set('Authorization', authService.getAuthorizationHeaderValue());

    if (init.body && !init.headers.has('Content-Type') && init.method === 'POST')
        init.headers.set('Content-Type', 'application/json')

    return fetch(`${API_URL}/${path}`, init);
}
